

var Application = require("../Application.js");
var ApplicationContext = require("../config/ApplicationContext.js");


class LoginUtil{

	constructor(){}

	goLogin(url){
        if(url){
            Application.dataStore.doAuth(url);
        } else {
            Application.dataStore.doAuth(`${window.location.pathname}`);
        }
    }

    // use this to check if the user is logged in
    // without making a call to the server.
    // Use this in control components.
    isLogin(){
        if(ApplicationContext.getUserData()) return true;
        else return false;
    }

    // this will check if the user is logged in and log them in
    // if they are not.  It will first check local isLogin then
    // check if the server has them as logged in.
    // Use this in page components.
    checkLogin(next, handleError) {
        if (ApplicationContext.getUserData()) {
            next();
        } else {
            Application.dataStore.getUserInfo(handleError).then(result => {
                if (result) {
                    next();
                } else {
                    Application.dataStore.doAuth(`${window.location.pathname}`);
                }
            })
        }
    }

    checkUrl(path, setURL, handleError){
        if(!path.includes("username")){return}

        if(ApplicationContext.getUserData()){
            setURL(ApplicationContext.getUserData());
        }else{
            Application.dataStore.getUserInfo(handleError).then(info => this.setUrl(ApplicationContext.getUserData()));
        }
    }
}

module.exports = new LoginUtil();